// extracted by mini-css-extract-plugin
export default {"page":"userprofilepage_page__pK81H","userProfileBlock":"userprofilepage_userProfileBlock__Q7yoC"};